<div *ngIf="selectedFirLayer != null" class="modal active">
    <div class="modal__container modal__container--sm">
        <div class="fields">
            <h2>Selection by FIR</h2>
            <div class="close" (click)="close()"><img src="/assets/img/close-white.svg" alt="" /></div>
            <div class="fields__container">
                <form autocomplete="off"  name="selectionByFirForm" #ngForm="ngForm" id="selectionByFirForm" class="active">
                    <div class="fields__block">
                        <div class="fields__block__section">
                            <div class="title">
                                <h4>FIR Layer</h4>
                                <span> </span>
                            </div>
                            <div class="dropdown-fields">
                                <div>
                                    <label for="">FIR Layer Selection</label>
                                    <select id="FIR" name="selectedFIR" [(ngModel)]="selectedFirLayer">
                                        <option  *ngFor="let firLayer of firLayersList" [ngValue]="firLayer">
                                            {{ firLayer.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div class="fields__block__section">
                            <div class="title">
                                <h4>DEMETER Entities</h4>
                                <span> </span>
                            </div>
                            <div class="dropdown-fields">
                                <div>
                                    <label for="">Entity Selection</label>
                                    <select id="entity" name="selectedEntity" [(ngModel)]="selectedEntity">
                                        <option  *ngFor="let entity of entitiesList" [ngValue]="entity">{{ entity }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="fields__btn">
                        <button type="submit" [ngClass]="ngForm.form.valid? 'blue' : 'gray'" 
                        (click)="setSelectionEvent()" [disabled]="!ngForm.form.valid">
                            Ok
                        </button>
                        <button type="button" class="gray" (click)="close()">Cancel</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
  </div>
  
